import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useGuinchosGuindastesSection } from "./use-guinchos-guindastes-section";
import { GuinchosGuindastesSectionView } from "./view-guinchos-guindastes-section";

export function GuinchosGuindastesSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useGuinchosGuindastesSection(props);

  return <GuinchosGuindastesSectionView {...vm} />;
}

export type * from "./types-guinchos-guindastes-section";
